// Elektronischer Beleg nach § 132a BAO (ab 1.10.2026). Siehe tools/E-BELEG.md.
//
// Was dieses Modul tut:
//   1. liest die Belegausgabe aus ini.txt ("Belegausgabe PAPIER|DIGITAL|BEIDE",
//      fehlt der Schluessel oder ist er unbekannt: BEIDE, siehe VOREINSTELLUNG),
//   2. schneidet den fertig aufgebauten Bon aus dem CPrinter mit - dieselben
//      Zeilen, dieselbe Spaltenaufteilung (CPrinter.layoutLine) wie auf Papier,
//      dazu RKSV-QR-Inhalt und JWS - und rendert ihn als HTML,
//   3. uebergibt beides samt RKSV-QR als Matrix dem lokalen Kassenserver
//      (POST /ebeleg). Der setzt den Beleg als PDF (Nutzer 12.10.2026: "Der
//      eBeleg soll pdf sein"), legt unter var/belege/JJJJ-MM/ ab, vergibt ein
//      zufaelliges Token und laedt zum zentralen Belegdienst hoch (Stufe 1). Klappt der Upload, zeigt das
//      Kundendisplay den Link als QR-Code (CDisplay.zeigeBelegQR),
//   4. dokumentiert die Art der Belegerteilung pro Beleg in der LOKALEN Tabelle
//      BELEGAUSGABE (PAPIER / PAPIER+DIGITAL / DIGITAL). Bewusst NICHT als
//      Spalte in BON: ExportPOSDBfromMysql.sh auf dem zentralen Server kopiert
//      BON per SELECT * - eine zusaetzliche Spalte verschiebt dort die Spalten.
//      Die Tabelle steht in keiner Routing-Regel (core/sqlite.js), bleibt also
//      auch auf einer Slave-Kasse lokal.
//
// DIGITAL allein (ohne Papier) ist noch gesperrt: der Druck faellt vor dem
// Ende des Uploads, ein unterdrueckter Bon waere bei scheiterndem Upload ein
// nicht erteilter Beleg. DIGITALE_UEBERGABE_AKTIV erst freischalten, wenn der
// Druck auf das Upload-Ergebnis wartet.

var DIGITALE_UEBERGABE_AKTIV = false;
var MODI = ["PAPIER", "DIGITAL", "BEIDE"];
var tabelleAngelegt = false;
var warnungDigitalGeloggt = false;

// Voreinstellung BEIDE (Nutzer-Entscheid 28.9.2026: "im ersten Schritt Papier
// und digital aktiviert"). Pro Kasse per ini.txt uebersteuerbar.
var VOREINSTELLUNG = "BEIDE";

function belegausgabeModus(envProperties) {
    var env = envProperties || (window.POS && POS.EnvProperties) || {};
    var wert = String(env.BELEGAUSGABE || "").trim().toUpperCase();
    if (!wert) return VOREINSTELLUNG;
    if (MODI.indexOf(wert) >= 0) return wert;
    log.add(2, "Warning", "Belegausgabe unbekannt", wert + " - es gilt " + VOREINSTELLUNG);
    return VOREINSTELLUNG;
}

// Wird Papier gedruckt? In Stufe 0 immer.
function papierDrucken(modus) {
    if (modus !== "DIGITAL") return true;
    if (!DIGITALE_UEBERGABE_AKTIV) {
        if (!warnungDigitalGeloggt) {
            warnungDigitalGeloggt = true;
            log.add(2, "Warning", "Belegausgabe DIGITAL",
                "noch kein digitaler Uebergabeweg - es wird weiter Papier gedruckt");
        }
        return true;
    }
    return false;
}

// Rueckuebersetzung der Drucker-Codepage (siehe CPrintingLineElement).
var CODEPAGE = { 0xD5: "€", 0x81: "ü", 0x9A: "Ü", 0x84: "ä",
                 0x8E: "Ä", 0x94: "ö", 0x99: "Ö", 0xE1: "ß" };

function dekodiere(buf) {
    var s = "";
    for (var i = 0; i < buf.length; i++) {
        var b = buf[i];
        s += b < 0x80 ? String.fromCharCode(b) : (CODEPAGE[b] || "?");
    }
    return s;
}

// Zeilen aus dem CPrinter, VOR print() aufzurufen (print() leert den Puffer).
function erfasseZeilen(printer) {
    var zeilen = [];
    for (var i = 0; i < printer.lineCount; i++) {
        var line = printer.lines[i];
        if (line.type == "LN") {
            var elemente = printer.layoutLine(line);
            if (line.elementCount == 0) {
                zeilen.push({ typ: "text", text: "" });
                continue;
            }
            var text = "";
            for (var e = 0; e < elemente.length; e++) {
                while (text.length < elemente[e].start) text += " ";
                text += dekodiere(elemente[e].text);
            }
            // Fett wie auf Papier: print() setzt ESC E aus line.underline,
            // nicht aus element.bold (vorbestehend, bewusst nachgebildet).
            zeilen.push({ typ: "text", text: text, schrift: line.font,
                          vergroesserung: line.magnification, fett: !!line.underline });
        } else if (line.type == "BC") {
            zeilen.push({ typ: "barcode", text: String(line.text) });
        } else if (line.type == "IM") {
            zeilen.push({ typ: "bild" });
        }
    }
    return zeilen;
}

function baueEBeleg(printer, receipt, receiptId, bonId, modus) {
    return {
        format: "posweb-ebeleg/1",
        kasse: String(POS.POSId),
        receiptId: receiptId,
        bonId: bonId,
        erstellt: new Date().toISOString(),
        belegausgabe: modus,
        zeilen: erfasseZeilen(printer),
        rksv: {
            qr: receipt ? receipt.getQRCodeRepresentation() : null,
            jws: receipt ? (receipt.jwsCompactRepresentation || null) : null
        }
    };
}

// RKSV-QR als Matrix ["0101...", ...] (1 = dunkel, ohne Ruhezone) - daraus
// zeichnet der Kassenserver den QR-Code in die PDF. jquery.qrcode zeichnet
// mit krummen Modulgroessen (unscharf); deshalb einmal gross zeichnen, die
// Modulgroesse am Finder-Muster ablesen (immer 7 Module breit) und die Matrix
// an den Modulmitten abtasten.
function qrMatrix(text) {
    var gross = 1200;
    var div = document.createElement("div");
    $(div).qrcode({ text: text, size: gross, ecLevel: "M", render: "canvas" });
    var quelle = div.firstChild;
    var ctx = quelle.getContext("2d");
    var px = ctx.getImageData(0, 0, gross, gross).data;
    // Helle Module zeichnet das Plugin TRANSPARENT (0,0,0,0) - dunkel ist
    // nur, was deckend UND dunkel ist.
    var dunkel = function (x, y) {
        var i = (Math.floor(y) * gross + Math.floor(x)) * 4;
        return px[i + 3] > 128 && px[i] < 128;
    };
    var lauf = 0;
    while (lauf < gross && dunkel(lauf, 1)) lauf++;
    var n = Math.round(gross / (lauf / 7));
    var modul = gross / n;
    var zeilen = [];
    for (var r = 0; r < n; r++) {
        var z = "";
        for (var c = 0; c < n; c++)
            z += dunkel((c + 0.5) * modul, (r + 0.5) * modul) ? "1" : "0";
        zeilen.push(z);
    }
    return zeilen;
}

// QR-Code als kleines, scharfes PNG (2 px je Modul) aus der Matrix. Die
// Anzeige skaliert per CSS "image-rendering: pixelated" verlustfrei hoch.
function qrBild(text, matrix) {
    var m = matrix || qrMatrix(text);
    var n = m.length;
    var rand = 4, faktor = 2;
    var ziel = document.createElement("canvas");
    ziel.width = ziel.height = (n + 2 * rand) * faktor;
    var z = ziel.getContext("2d");
    z.fillStyle = "#fff";
    z.fillRect(0, 0, ziel.width, ziel.height);
    z.fillStyle = "#000";
    for (var r = 0; r < n; r++)
        for (var c = 0; c < n; c++)
            if (m[r][c] == "1")
                z.fillRect((c + rand) * faktor, (r + rand) * faktor, faktor, faktor);
    return ziel.toDataURL("image/png");
}

// Uebergibt Beleg + HTML + RKSV-QR-Matrix an den lokalen Kassenserver
// (POST /ebeleg), der die PDF setzt, ablegt und zum zentralen Belegdienst
// hochlaedt. Liefert jQuery-Deferred
// (Regel 4 im Runbook) mit { datei, url, hochgeladen } oder null.
function sendeEBeleg(beleg, html, qr) {
    var dfd = jQuery.Deferred();
    $.ajax({
        url: "ebeleg",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify({ beleg: beleg, html: html, qr: qr || null }),
        cache: false,
        timeout: 10000,
        success: function (antwort) {
            if (antwort && antwort.ok) return dfd.resolve(antwort);
            log.add(2, "Error", "e-Beleg nicht angenommen", JSON.stringify(antwort));
            dfd.resolve(null);
        },
        error: function (xhr) {
            log.add(2, "Error", "e-Beleg nicht gespeichert", xhr && xhr.status);
            dfd.resolve(null);
        }
    });
    return dfd.promise();
}

function sqlText(wert) {
    return wert == null ? "NULL" : "'" + String(wert).replace(/'/g, "''") + "'";
}

function dokumentiereBelegausgabe(receiptId, bonId, art, datei) {
    var zeit = new Date().toISOString().slice(0, 19);
    if (!tabelleAngelegt) {
        tabelleAngelegt = true;
        POS.SQLiteCon.execute("CREATE TABLE IF NOT EXISTS BELEGAUSGABE (ReceiptID INTEGER PRIMARY KEY NOT NULL, BON_ID INTEGER, Art CHAR (16), Zeit CHAR (19), Datei VARCHAR (256), Exported INTEGER DEFAULT 0)");
    }
    return POS.SQLiteCon.execute("INSERT OR REPLACE INTO BELEGAUSGABE (ReceiptID, BON_ID, Art, Zeit, Datei) VALUES (" +
        Number(receiptId) + ", " + Number(bonId) + ", " + sqlText(art) + ", " + sqlText(zeit) + ", " + sqlText(datei) + ")");
}

// Einstieg aus CReceiptPrinter.printBon, direkt VOR Printer.print().
// Gilt nur fuer den Kundenbeleg mit RKSV-QR-Code: printMode "bill" (Knopf
// "Bon drucken", CTransactionShowMode/CCardPaymentMode/Bankomat) oder
// "normal" (Voreinstellung). Kopien, Anzahlungen, Stornoprotokolle usw.
// bleiben unveraendert Papier.
var KUNDENBELEG_MODI = ["bill", "normal"];
// Rueckgabe: { papier: bool } - der Aufrufer druckt nur, wenn papier true ist.
// bonManager.eBelegFertig (Stufe 2, Hello Again): jQuery-Deferred, loest mit
// { beleg, url } auf, sobald der e-Beleg abgelegt/hochgeladen ist
// (url nur bei erfolgreichem Upload) - oder mit null, wenn es fuer diesen
// Druck keinen e-Beleg gibt. Der Hello-Again-Versand wartet darauf.
function eBelegVorDruck(bonManager, printer, withQRCode, receiptId) {
    var ergebnis = { papier: true };
    var fertig = jQuery.Deferred();
    bonManager.eBelegFertig = fertig.promise();
    try {
        if (!withQRCode || !receiptId || KUNDENBELEG_MODI.indexOf(bonManager.printMode) < 0) {
            fertig.resolve(null);
            return ergebnis;
        }
        var modus = belegausgabeModus();
        ergebnis.papier = papierDrucken(modus);
        var bonId = bonManager.currentBonId;
        var art = ergebnis.papier ? "PAPIER" : "DIGITAL";
        if (modus === "PAPIER") {
            dokumentiereBelegausgabe(receiptId, bonId, art, null);
            fertig.resolve(null);
            return ergebnis;
        }
        var beleg = baueEBeleg(printer, bonManager.currentReceipt, receiptId, bonId, modus);
        var rksvMatrix = beleg.rksv.qr ? qrMatrix(beleg.rksv.qr) : null;
        var rksvBild = rksvMatrix ? qrBild(beleg.rksv.qr, rksvMatrix) : null;
        var html = renderEBelegHtml(beleg, rksvBild);
        $.when(sendeEBeleg(beleg, html, rksvMatrix)).done(function (erg) {
            // Digital erteilt ist der Beleg erst, wenn der Link auch geht:
            // nur dann QR-Code ans Kundendisplay und "+DIGITAL" dokumentieren.
            var digital = !!(erg && erg.url && erg.hochgeladen);
            if (digital && window.Display && Display.zeigeBelegQR)
                Display.zeigeBelegQR(erg.url, qrBild(erg.url));
            var belegArt = ergebnis.papier ? (digital ? "PAPIER+DIGITAL" : "PAPIER") : "DIGITAL";
            dokumentiereBelegausgabe(receiptId, bonId, belegArt, erg ? erg.datei : null);
            fertig.resolve({ beleg: beleg, url: digital ? erg.url : null });
        });
    } catch (e) {
        // Der e-Beleg darf den Kassiervorgang nie aufhalten - Papier geht immer.
        log.add(2, "Error", "e-Beleg", e && e.stack ? e.stack : String(e));
        ergebnis.papier = true;
        if (fertig.state() == "pending") fertig.resolve(null);
    }
    return ergebnis;
}

// Beleg als leerzeichenformatierter Text (Hello Again "receipt_text"):
// dieselben Zeilen wie auf Papier, dazu RKSV-Code und - falls vorhanden -
// der Link zum signierten e-Beleg.
function belegText(beleg, url) {
    var zeilen = [];
    beleg.zeilen.forEach(function (z) {
        if (z.typ == "text" || z.typ == "barcode") zeilen.push(String(z.text || "").replace(/\s+$/, ""));
    });
    if (beleg.rksv && beleg.rksv.qr) zeilen.push("", beleg.rksv.qr);
    if (url) zeilen.push("", "Digitaler Beleg: " + url);
    return zeilen.join("\r\n");
}

// HTML-Darstellung (nur noch lokale Ablage auf der Kasse - der Link liefert
// seit 12.10.2026 die PDF aus dem Kassenserver). qrBildUrl ist
// ein data:-URL des RKSV-QR-Codes; er ersetzt die erste Bildzeile des Bons.
function htmlEscape(s) {
    return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

// Geometrie wie am Drucker: Schrift B = 56, Schrift A = 42 Spalten auf
// derselben Papierbreite; Vergroesserung m wie in CPrinter.print()
// (Breite floor(m/2-0.5)+1, Hoehe floor(m/2)+1). Alles in em relativ zur
// Grundschrift von <main>, die sich nach der Bildschirmbreite richtet
// (Handy: 56 Zeichen muessen ohne Querscrollen passen).
function zeilenStil(z) {
    var m = z.vergroesserung || 1;
    var breite = Math.floor(m / 2 - 0.5) + 1;
    var hoehe = Math.floor(m / 2) + 1;
    var em = (z.schrift == "A" ? 56 / 42 : 1) * breite;
    var stil = "font-size:" + em.toFixed(3) + "em;line-height:" + (1.3 * hoehe / breite).toFixed(3);
    if (hoehe != breite)
        stil += ";transform:scaleY(" + (hoehe / breite) + ");transform-origin:left center";
    return stil;
}

function renderEBelegHtml(beleg, qrBildUrl) {
    var qrGesetzt = false;
    var koerper = beleg.zeilen.map(function (z) {
        if (z.typ == "bild") {
            if (qrGesetzt || !qrBildUrl) return "";
            qrGesetzt = true;
            return '<img class="qr" alt="RKSV-QR-Code" src="' + qrBildUrl + '">';
        }
        if (z.typ == "barcode") return '<div class="z">' + htmlEscape(z.text) + "</div>";
        return '<div class="z' + (z.fett ? " f" : "") + '" style="' + zeilenStil(z) + '">' +
            (htmlEscape(z.text) || "&nbsp;") + "</div>";
    }).join("\n");
    return '<!doctype html><html lang="de"><head><meta charset="utf-8">' +
        '<meta name="viewport" content="width=device-width,initial-scale=1">' +
        "<title>Beleg " + htmlEscape(beleg.kasse + "-" + beleg.receiptId) + "</title>" +
        "<style>body{margin:0;background:#eee}.rolle{overflow-x:auto}" +
        // 56 Zeichen Monospace ~ 33,6em; Grundschrift hoechstens 12px, auf
        // schmalen Schirmen kleiner. "monospace,monospace" verhindert die
        // Browser-Verkleinerung von reinem "monospace".
        "main{background:#fff;width:56ch;margin:1em auto;padding:1em;color:#000;" +
        "font-family:monospace,monospace;font-size:min(12px,calc((100vw - 2.5em) / 33.6))}" +
        ".z{white-space:pre}.f{font-weight:bold}.qr{display:block;margin:.5em auto;width:16em;height:16em;image-rendering:pixelated}" +
        ".rksv{word-break:break-all;white-space:normal;font-size:.85em;color:#555;margin-top:1em}</style></head>" +
        '<body><div class="rolle"><main>' + koerper +
        '<div class="rksv">' + htmlEscape(beleg.rksv.qr || "") + "</div></main></div></body></html>";
}

export {
    belegausgabeModus, papierDrucken, erfasseZeilen, baueEBeleg, qrMatrix, qrBild,
    sendeEBeleg, dokumentiereBelegausgabe, eBelegVorDruck, renderEBelegHtml,
    belegText
};
